import { getDefaultData } from './get-default-data';
import { navigation } from '@exploration/cms-constants';

const cmsData = getDefaultData();
const learnLinks = [
  cmsData.callToAction?.[
    navigation.resources_navigation_links.insights_and_guidance
  ],
  cmsData.callToAction?.[
    navigation.resources_navigation_links.financial_education_events
  ],
  cmsData.callToAction?.[
    navigation.resources_navigation_links.market_and_economic_updates
  ],
  cmsData.callToAction?.[
    navigation.resources_navigation_links.tools_and_calculators
  ],
].map((link) => ({
  label: link.text,
  target: link.target,
  altText: link.text,
  url: link.href,
}));

const getHelpLinks = [
  cmsData.callToAction?.[
    navigation.resources_navigation_links.client_resources
  ],
  cmsData.callToAction?.[navigation.resources_navigation_links.contact_us],
  cmsData.callToAction?.[navigation.resources_navigation_links.faqs],
].map((link) => ({
  label: link.text,
  target: link.target,
  altText: link.text,
  url: link.href,
}));

const promoCard = {
  title:
    cmsData?.text?.[navigation.resources_promo_card.resources_promo_card_title],
  description:
    cmsData?.text?.[
      navigation.resources_promo_card.resources_promo_card_description
    ],
  callToAction: {
    label:
      cmsData?.callToAction?.[
        navigation.resources_promo_card.resources_promo_card_call_to_action
      ].text,
    url: cmsData?.callToAction?.[
      navigation.resources_promo_card.resources_promo_card_call_to_action
    ].href,
  },
};

export const ResourceLinks = {
  learnLinks,
  getHelpLinks,
  promoCard,
};
